var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBorderless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5C3.5 2.67188 4.17188 2 5 2C5.82812 2 6.5 2.67188 6.5 3.5C6.5 4.16719 6.06406 4.73281 5.46094 4.92812C5.01719 5.07188 4.5 5.47969 4.5 6.125V6.5C4.5 6.77656 4.72344 7 5 7C5.27656 7 5.5 6.77656 5.5 6.5V6.125C5.5 6.09844 5.50938 6.06094 5.55469 6.01094C5.60156 5.95938 5.67813 5.90937 5.76875 5.87969C6.77344 5.55625 7.5 4.61406 7.5 3.5C7.5 2.11875 6.38125 1 5 1C3.61875 1 2.5 2.11875 2.5 3.5C2.5 3.77656 2.72344 4 3 4C3.27656 4 3.5 3.77656 3.5 3.5ZM5 9C5.34531 9 5.625 8.72031 5.625 8.375C5.625 8.02969 5.34531 7.75 5 7.75C4.65469 7.75 4.375 8.02969 4.375 8.375C4.375 8.72031 4.65469 9 5 9Z",
    fill: "#F4FDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBorderless);
export default __webpack_public_path__ + "static/media/help-borderless.6e913c7267f2e0f9bde9760263b3f315.svg";
export { ForwardRef as ReactComponent };